import React from 'react';
import PropTypes from 'prop-types';
import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import GpsOffOutlinedIcon from '@mui/icons-material/GpsOffOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import { PRESET_KEYS, PRESET_LABELS } from '../constants';

const PRESET_ICONS = {
  [PRESET_KEYS.ANOMALIAS]: <ReportProblemOutlinedIcon fontSize="small" />,
  [PRESET_KEYS.BACKLOG]: <PendingActionsOutlinedIcon fontSize="small" />,
  [PRESET_KEYS.GPS]: <GpsOffOutlinedIcon fontSize="small" />,
  [PRESET_KEYS.COMPLETO]: <MapOutlinedIcon fontSize="small" />,
};

const PRESET_ORDER = [
  PRESET_KEYS.ANOMALIAS,
  PRESET_KEYS.BACKLOG,
  PRESET_KEYS.GPS,
  PRESET_KEYS.COMPLETO,
];

const NsirMapaPresets = ({ activePreset, onSelectPreset }) => {
  const handleChange = (_, value) => {
    if (value != null) onSelectPreset(value);
  };

  return (
    <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700 }}>
        Modos:
      </Typography>
      <ToggleButtonGroup
        value={activePreset}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          flexWrap: 'wrap',
          '& .MuiToggleButton-root': {
            px: 1.5,
            py: 0.5,
            textTransform: 'none',
            fontSize: '0.8125rem',
            gap: 0.5,
          },
        }}
      >
        {PRESET_ORDER.map((key) => (
          <ToggleButton key={key} value={key}>
            {PRESET_ICONS[key]}
            {PRESET_LABELS[key]}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};

NsirMapaPresets.propTypes = {
  activePreset: PropTypes.string,
  onSelectPreset: PropTypes.func.isRequired,
};

NsirMapaPresets.defaultProps = {
  activePreset: null,
};

export default NsirMapaPresets;
